import React from 'react';

import {DocumentUtils} from "../../Utils/DocumentUtils";

export class PageHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let targetTitle = this.props.Title;

        if (DocumentUtils.GetTitle() !== targetTitle) {
            DocumentUtils.SetTitle(targetTitle);
        }

        //TODO: Add open graph? Other Page Metadata?

        //This component doesn't really render anything. It's just to manage page header details inside our react app.
        return null;
    }
}


